import { render } from "./LoaderFullPage.vue?vue&type=template&id=7706d06e"
import script from "./LoaderFullPage.vue?vue&type=script&lang=js"
export * from "./LoaderFullPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__